import RequestBenefit from "./RequestBenefit";

export default interface RequestBenefitData {
  isConsentAccepted: boolean;
  isCriminalLiabilityAccepted: boolean;
  benefits: RequestBenefit[];
}

export const requestBenefitDataInitial: RequestBenefitData = {
  isConsentAccepted: false,
  isCriminalLiabilityAccepted: false,
  benefits: [],
};
